import React from 'react';
import { Button } from '@jem-open/jem-ui';
import { BulkDownloadButtonProps } from '../types/types';

const BulkDownloadButton: React.FC<BulkDownloadButtonProps> = ({
  selectedBatchIds,
  selectedCount,
  onDownload,
  downloadState,
  disabled = false,
  className = ''
}) => {
  const handleClick = async () => {
    if (!downloadState.inProgress && selectedBatchIds.length > 0) {
      await onDownload(selectedBatchIds);
    }
  };

  const isDisabled = disabled || downloadState.inProgress || selectedCount === 0;
  const buttonText = downloadState.inProgress
    ? 'Downloading...'
    : `Download Selected (${selectedCount})`;

  return (
    <Button
      variant="primary"
      onClick={handleClick}
      disabled={isDisabled}
      className={className}
      aria-label={`Download ${selectedCount} selected batches`}
    >
      {buttonText}
    </Button>
  );
};

export default BulkDownloadButton;